/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Microsoft_UnverifiedInputs */



/**
* | output |
* | --- |
* | "We couldn't verify that Microsoft account." |
*
* @param {Login_Microsoft_UnverifiedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_microsoft_unverified = /** @type {((inputs?: Login_Microsoft_UnverifiedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Microsoft_UnverifiedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden dat Microsoft-account niet verifiëren.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu vérifier ce compte Microsoft.")
	return /** @type {LocalizedString} */ ("We couldn't verify that Microsoft account.")
});